<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div v-if="configuracion.hash_teatro == 'hvLux5tvnE5HMsDiXOt2'">
            <FormInput :label="$t('formularios.dni')" name="dni" rules="required" v-model="abonado.dni" />
        </div>
        <div v-else>
            <FormInput :label="$t('formularios.dni')" name="dni" rules="required" v-model="abonado.dni" />
            <FormInput class="mb-3 mb-lg-4" v-if="n_abonado" :label="$t('formularios.n_abonado_anterior')" name="n_abonado_antiguo" rules="required" v-model="abonado.n_abonado_antiguo" />
        </div>
        
        <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_abono.renovar') }}</span></button>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['abonado', 'n_abonado'],
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
    }
</script>

<style>

</style>
